import cn from '@integrations/classnames'
import { createElement, type HTMLAttributes } from '@integrations/react'
import styles from './ModalTitle.module.scss'

interface Props extends HTMLAttributes<HTMLElement> {
  as?: 'div' | 'h3'
}

export function ModalTitle({ as = 'div', children, className, ...props }: Props) {
  return createElement(as, { className: cn(styles['modal-title'], 'modal-title', className), ...props }, children)
}
